import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TriangleAlert } from "lucide-react";
import { api, moisLabel } from "@/lib/api";

// Bandeau : mois dont la conciliation bancaire ne balance pas
export const AlerteBanque = () => {
  const [liste, setListe] = useState([]);
  useEffect(() => { api.get("/conciliation-bancaire/alertes").then((r) => setListe(r.data)).catch(() => {}); }, []);
  if (!liste.length) return null;
  return (
    <div className="mb-6 flex flex-wrap items-start gap-3 rounded-lg border border-red-200 bg-red-50 px-4 py-3" data-testid="alerte-banque">
      <TriangleAlert className="mt-0.5 h-4 w-4 shrink-0 text-red-600" />
      <div className="flex-1 min-w-0 text-sm text-red-900">
        <p className="font-medium">Conciliation bancaire : {liste.length} mois ne balance{liste.length > 1 ? "nt" : ""} pas</p>
        {liste.slice(0, 4).map((m) => <p key={m.mois} data-testid={`alerte-banque-${m.mois}`}>{moisLabel(m.mois)} : {m.problemes.join(" ; ")}</p>)}
      </div>
      <Link to="/conciliation-bancaire" className="text-sm font-medium text-emerald-700 hover:underline" data-testid="alerte-banque-voir">Voir la conciliation</Link>
    </div>
  );
};
